import { render, staticRenderFns } from "./PostEditWeb.vue?vue&type=template&id=cfec6cf2"
import script from "./PostEditWeb.vue?vue&type=script&lang=js"
export * from "./PostEditWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfec6cf2')) {
      api.createRecord('cfec6cf2', component.options)
    } else {
      api.reload('cfec6cf2', component.options)
    }
    module.hot.accept("./PostEditWeb.vue?vue&type=template&id=cfec6cf2", function () {
      api.rerender('cfec6cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/app2/components/community/PostEditWeb.vue"
export default component.exports